import { FC, ReactElement } from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Text } from '../../Text';

import { ICheckboxProps } from './checkbox.interface';
import styles from './checkbox.module.scss';

import { Check, Minus } from 'views/components/UI/Icons/Icons';

const Checkbox: FC<ICheckboxProps> = (props): ReactElement => {
  const {
    type = 'checkbox',
    label,
    isSpecial,
    intlValues,
    isShowFormattedMessage = true,
    ...restProps
  } = props;

  return (
    <div className={classNames(styles.checkbox, label ? styles.checkbox__maxWidth : '')}>
      <label>
        <input type={type} className={styles.input} {...restProps} />
        {isSpecial ? (
          <span className={styles.custom__special} aria-hidden="true">
            <Minus size={12} className={styles.mark} />
          </span>
        ) : (
          <span className={styles.custom} aria-hidden="true">
            <Check size={12} className={styles.mark} />
          </span>
        )}
        {label &&
          (isShowFormattedMessage ? (
            <Text>
              <FormattedMessage id={label} values={{ ...intlValues }} />
            </Text>
          ) : (
            <div className={styles.label__description}>{label}</div>
          ))}
      </label>
    </div>
  );
};

export { Checkbox };
